import { apiDataService } from "@/services/apiDataService";
export default {
	namespaced: true,
	state: {
		categories: [],
		error: null,
		loading: false,
	},
	mutations: {
		SET_CATEGORIES(state, categories) {
			state.categories = categories;
		},
		SET_ERROR(state, error) {
			state.error = error;
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async fetchAllCategories({ commit }) {
			commit("SET_LOADING", true);
			commit("SET_ERROR", null); // clear previous error
			try {
				const response = await apiDataService.getCategories();
				commit("SET_CATEGORIES", response.data);
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to fetch events");
			} finally {
				commit("SET_LOADING", false);
			}
		},
	},
	getters: {
		allCategories: (state) => state.categories,
		fetchError: (state) => state.error,
		isLoading: (state) => state.loading,
	},
};
